import { CaseSource, instance } from './api';

export interface CaseSourceOption {
  value: string;
  label: string;
  caseSource: CaseSource;
}

export enum Tab {
  Search = 'Search',
  Map = 'Map',
  Cases = 'Cases',
  Population = 'Population',
  Property = 'Property'
}

export interface Config {
  id: string;
  name: string;
  description: string;
  map: string[];
  tabs: Tab[];
}

export interface ConfigFormData {
  id: string;
  name: string;
  description: string;
  map: string[];
  tabs: Tab[];
  caseSources: CaseSourceOption[];
}

export async function getConfigs() {
  const { data } = await instance.get<Config[]>('configs');
  return data;
}

export async function getConfig(id: string) {
  const { data } = await instance.get<Config>(`configs/${id}`);
  return data;
}

export async function getCaseSourceOptions() {
  const { data } = await instance.get<CaseSourceOption[]>('configs/caseSourceOptions');
  return data;
}

export async function deleteConfig(id: string) {
  const url = `configs/${id}`;
  const { data } = await instance.delete(url);
  return data;
}

export async function createConfig(config: ConfigFormData) {
  const { data } = await instance.post('configs', config);
  return data;
}

export async function updateConfig(config: ConfigFormData) {
  const { data } = await instance.put('configs', config);
  return data;
}

export async function getFormData(id: string) {
  const url = `configs/formData/${id}`;
  const { data } = await instance.get<ConfigFormData>(url);
  return data;
}
